<template>
  <Modal v-if="showModalAssign" @close="$emit('closeModal')">
    <div class="assignDelivery">
      <div class="assignDelivery__header">
        <span class="title">{{ $t('assignDeliveryFromDesk') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="assignDelivery__description">
        <label class="label-description" for="description">
          {{ $t('description') }}
        </label>
        <textarea
          id="description"
          v-model="description"
          class="input-description"
          maxlength="250"
        >
        </textarea>
      </div>
      <div class="assignDelivery__button">
        <Button
          variant="filled"
          :title="$t('save')"
          @click="$emit('assignDeliveryRequest', idDelivery, description)"
        />
      </div>
      <div class="assignDelivery__body">
        <span class="title">{{ $t('assignDeliveryFromLocker') }}</span>
        <span class="warning">{{ $t('assignToLocker') }}</span>
      </div>
      <div class="assignDelivery__buttons">
        <Button
          class="assignDelivery__buttons-redirect"
          variant="filled"
          :title="$t('redirectToPickupBox')"
          @click="redirectToPickupBox"
        />
        <Button
          variant="redBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

import { goToPickupBox } from '@/utils/goToPickupBox';

@Options({
  name: 'AssignDelivery',
  props: ['showModalAssign', 'idDelivery'],
  data() {
    return {
      boxId: '',
      description: ''
    };
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy'])
  },
  methods: {
    redirectToPickupBox() {
      const { id } = this.$route.params;

      this.boxId = this.pharmacy?.pickupBoxes[0];

      goToPickupBox(id, this.boxId);
    }
  }
})
export default class AssignDelivery extends Vue {}
</script>

<style lang="scss">
.assignDelivery {
  width: 400px;
  height: 100%;
  padding: 24px;
  .assignDelivery__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .assignDelivery__description {
    position: relative;
    margin-bottom: 24px;
    label {
      position: absolute;
      font-family: 'Ubuntu-Regular';
      top: -6px;
      left: 15px;
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
    textarea {
      width: 366px;
      height: 100px;
      padding: 16px;
      font-size: $fourteenSize;
      border: 1px solid $border;
      border-radius: 8px;
      resize: none;
      &:focus {
        outline: none;
      }
    }
  }
  .assignDelivery__body {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 24px 0;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $sixteenSize;
      line-height: $fifteenSize;
      margin: 23px 0;
    }
    .warning {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
  }
  .assignDelivery__buttons {
    .assignDelivery__buttons-redirect {
      width: 190px;
      margin-right: 12px;
    }
  }
}
</style>
